import { Toolbar } from "primereact/toolbar";
import { IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IModal } from "./Company_Document";
import { Fetch } from "../../shared/Fetch";

export interface IEmptyDocument {
    document_ID?: number,
    document_Name?: string,
    document_Status?: string,
    createdOn?: Date,
    user_Added_By?: number,
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyDocument = {
    document_Name: "",
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEmptyDocument>, loading: boolean });
    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (


            <div className="my-2">
                <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
            </div>

        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Company Document</h5>
        </div>
    );

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyDocument });
    };
    const openEdit = (rowData: IEmptyDocument) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const action = (rowData: IEmptyDocument) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Company_DocumentMast", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const toggleVal = async (document_ID: number) => {
        const response = await Fetch("Company_DocumentMast/togglestatus", "PUT", null, `document_ID=${document_ID}`, props.toast);
        if (response) {
            let message: string = "Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };


    const user_TStatus = (rowData: any) => {
        return (
            <span style={{ color: rowData.document_Status ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { toggleVal(rowData.document_ID) }}>{rowData.document_Status ? "Active" : "Inactive"}</span>
        );

    };


    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="document_Name" header="Document Name" />
                <Column field="" header="Status " style={{ maxWidth: "20rem" }} body={user_TStatus} />

                <Column field="" header="Action" body={action} />
            </DataTable>
        </>
    );
}